module.exports = __webpack_public_path__ + "static/media/101.75ffa2ad.png";